import { useLayoutEffect, useRef } from "react";
import { SettingsItem } from "./SettingsItem";

export const ImageSetting = ({
  className = "",
  onChange = () => false,
  value = null,
}) => {
  const fileInputRef = useRef(null);

  const handleFileSelection = () => {
    const fileInput = fileInputRef.current;
    if (fileInput && fileInput.files.length) {
      const file = fileInput.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        onChange(e.target.result);
        // TODO: Reset file input state.
      };
      reader.onerror = () => {
        console.log("There was an error, fool!");
      };
    }
  };

  const handleUploadClick = (e) => {
    e.preventDefault();
    const fileInput = fileInputRef.current;
    if (fileInput) {
      fileInput.click();
    }
  };


  useLayoutEffect(() => {
    const fileInput = fileInputRef.current;
    if (fileInput) {
      fileInput.addEventListener("change", handleFileSelection);
      return () => {
        fileInput.removeEventListener("change", handleFileSelection);
      };
    }
  });

  return (
    <SettingsItem title="Mock-up" className={className}>
      <p className="pb-8">
        Recommended resolution of the image: 1,125 x 2,436 (PNG or JPG)
      </p>
      <button
        className="transition duration-100 ease-in-out secondary mb-6 hover:bg-gray-200"
        onClick={handleUploadClick}
        type="button"
      >
        Upload
      </button>
      <input
        type="file"
        accept=".jpg,.jpeg,.png"
        className="hidden w-0 h-0"
        ref={fileInputRef}
      />
    </SettingsItem>
  );
};
